import Icon from "@mui/material/Icon";

import AboutUs from "pages/LandingPages/AboutUs";
import ContactUs from "pages/LandingPages/ContactUs";
import Expertise from "pages/LandingPages/Expertise";

const routes = [
  {
    name: "about us",
    icon: <Icon>dashboard</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "",
        collapse: [
          {
            name: "Who We Are",
            route: "/pages/about-us/who-we-are",
            component: <AboutUs index="who-we-are" />,
          },
          {
            name: "Team",
            route: "/pages/about-us/team",
            component: <AboutUs index="team" />,
          },
          {
            name: "Values And Commitment",
            route: "/pages/about-us/values-and-commitment",
            component: <AboutUs index="values-and-commitment" />,
          },
        ],
      },
    ],
  },
  {
    name: "Our Expertise",
    icon: <Icon>view_day</Icon>,
    columns: 1,
    rowsPerColumn: 10,
    collapse: [
      {
        name: "",
        collapse: [
          {
            name: "Dynamic Student Housing",
            route: "/pages/expertise/dynamic-student-housing",
            component: <Expertise index="dynamic-student-housing" />,
          },
          {
            name: "Residential and Multi-Family Communities",
            route: "/pages/expertise/residential-and-multi-family-communities",
            component: <Expertise index="residential-and-multi-family-communities" />,
          },
          {
            name: "Powerful Public-Private Partnerships",
            route: "/pages/expertise/powerful-public-private-partnerships",
            component: <Expertise index="powerful-public-private-partnerships" />,
          },
          {
            name: "Premier Corporate Headquarters and Office Buildings",
            route: "/pages/expertise/premier-corporate-headquarters-and-office-buildings",
            component: <Expertise index="premier-corporate-headquarters-and-office-buildings" />,
          },
          {
            name: "Thriving Mixed-Use Developments",
            route: "/pages/expertise/thriving-mixed-use-developments",
            component: <Expertise index="thriving-mixed-use-developments" />,
          },
          {
            name: "Efficient Distribution and Logistic Centers",
            route: "/pages/expertise/efficient-distribution-and-logistic-centers",
            component: <Expertise index="efficient-distribution-and-logistic-centers" />,
          },
          {
            name: "Enhanced Public Facilities",
            route: "/pages/expertise/enhanced-public-facilities",
            component: <Expertise index="enhanced-public-facilities" />,
          },
        ],
      },
    ],
  },
  {
    name: "help & support",
    icon: <Icon>settings</Icon>,
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "",
        collapse: [
          {
            name: "contact us",
            route: "/pages/contact/message",
            component: <ContactUs index="message" />,
          },
          {
            name: "US Office",
            route: "/pages/contact/us-office",
            component: <ContactUs index="us-office" />,
          },
          {
            name: "Lagos Office",
            route: "/pages/contact/lagos-office",
            component: <ContactUs index="lagos-office" />,
          },
        ],
      },
    ],
  },
];

export default routes;
